import { createGlobalStyle } from "styled-components";

const MenuItemStyles = createGlobalStyle`
	.header-select-dropdown {
		padding: var(--space-3) 0;
		/* Grows out of the chip, so the seam is flat and only the free edge is
		   rounded. The chip squares its own bottom corners while open. */
		border-radius: 0 0 var(--radius-md) var(--radius-md);
		/* §4: where a panel is attached to its trigger the seam is one 1px line.
		   The chip already draws it, so the list does not draw a second. */
		border-top: none;
		/* rc-select keeps the trigger's width as the popup's minimum, so this is
		   only a ceiling: names longer than this wrap to a second line rather
		   than stretching the list across the screen. */
		max-width: 420px;
		.rc-virtual-list{
			padding: 0 var(--space-2);
		}
	}

	/* rc-select's built-in placements offset the popup 4px below the trigger
	   (rc-select/SelectTrigger.js, "offset: [0, 4]"), which reads as detached.
	   Scoped to the downward placement so a list that flips upward — where the
	   offset is -4 — is not pushed further away. */
	.header-select-dropdown.ant-select-dropdown-placement-bottomLeft {
		margin-top: -4px;
	}


	.header-select-dropdown .ant-select-item {
		padding: 0;
		&:last-of-type{
			> div > div{
				border-bottom: none;
			}
		}
		.switcher-item{
			padding: 8px 10px;
		}
	}

	/* The personal organization shows a translated label, not a stored name,
	   so it is set apart from the named organizations around it. The rule sits
	   on the span, so it holds in the list and in the closed switcher alike. */
	.switcher-item--personal span {
		font-weight: var(--font-weight-bold);
	}

	/* rewrite ant to solve 2 rows text */
	.header-select-dropdown .ant-select-item-option-content {
		white-space: inherit;
		> div {
			color: var(--color-text-secondary);
			&:hover *{
				color: var(--color-primary);
			}
		}
	}

	/* Remove styles from selected dropdown items */
	.header-select-dropdown
		.ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
		background-color: unset;
		.switcher-item,
		span{
			color: var(--color-primary);
		}
	}

	/* Selected item (outside dropdown) */
	.header-select .ant-select-selection-item {
		/* §8 calls this "a 14px value" and gives it no weight of its own. */
		font-weight: var(--font-weight-medium);
		> div{
			/* The chip gives the value its own 22px row (see Switcher.styles.tsx);
			   the MenuItem inside it adds no offset of its own. */
			padding: 0;
			min-height: 0;
			/* MenuItem draws a border-bottom to divide one dropdown row from the
			   next. The same component renders the closed switcher's value, where
			   that divider has nothing to divide and reads as a stray rule under
			   the organisation / project / scene name. */
			border-bottom: none;
		}
		img,
		svg {
			display: none;
		}
		span {
			min-height: 0;
			height: auto;
			max-height: none;
			line-height: 22px;
			/* MenuItem clamps a dropdown row to two lines and breaks long words to
			   do it. The closed chip has one 22px row, so the second line was
			   simply clipped — the name ended mid-word with no ellipsis. Here it
			   is one line that ellipses honestly. */
			display: block;
			-webkit-line-clamp: none;
			white-space: nowrap;
			word-break: normal;
			overflow: hidden;
			text-overflow: ellipsis;
		}
	}

	/* Hover item in dropdown (it temporary gets class "ant-select-item-option-active") */
	.header-select-dropdown .ant-select-item-option-active {
		background-color: var(--color-hover-ground);
	}
`;

export default MenuItemStyles;
